import { useTheme as useChakraTheme } from '@chakra-ui/react';
import { useColorPalettes } from './useColorPalettes';
export var useTheme = () => {
  var theme = useChakraTheme();
  var colorPalettes = useColorPalettes();
  return {
    colors: colorPalettes,
    textStyles: theme['textStyles'],
    fonts: theme['fonts']
  };
};
//# sourceMappingURL=useTheme.js.map